import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaStar,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaYoutube,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const YouTubeVideoProductionAgencyInDIFC = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="YouTube Video Production Agency in DIFC" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Grow Your YouTube Presence</Subheading>}
        heading={
          <Heading>
            YouTube <span tw="text-primary-500">Video Production</span> Agency
            in DIFC
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we are a premier YouTube video production agency
            in **DIFC**, creating high-quality, engaging, and platform-optimized
            videos that boost your channel’s visibility and subscriber growth.
            Elevate your brand with our cinematic storytelling.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1609921141835-710b7fa6e438?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Video production setup
          "https://images.unsplash.com/photo-1504465039542-a4308c88248f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // YouTube creative filming
          "https://images.unsplash.com/photo-1492619375914-88005aa9e8fb?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Content creation with Dubai background
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Your YouTube Video"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert YouTube Video Production in DIFC"
        description="We craft videos that drive YouTube success."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Cinematic Quality",
            description: "High-resolution videos with stunning visuals.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Expertise",
            description: "Proven success for DIFC YouTube channels.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Engaging Content",
            description: "Storytelling that captivates viewers.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Delivery",
            description: "Timely production for consistent uploads.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "YouTube Optimized",
            description: "Tailored for YouTube’s algorithm and formats.",
          },
          {
            icon: <FaYoutube color="#ff5464" size={40} />,
            title: "Subscriber Growth",
            description: "Videos designed to boost views and subscribers.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our YouTube Video Production Process"
        description={
          <Description>
            We create impactful YouTube videos with a strategic process:
            <ul tw="mt-4 list-disc pl-6">
              <li>
                Consultation: Align with your channel’s goals and audience.
              </li>
              <li>
                Concept Development: Craft engaging, trending video ideas.
              </li>
              <li>Filming: Capture with professional, cinematic equipment.</li>
              <li>
                Editing: Optimize for YouTube with thumbnails and captions.
              </li>
              <li>Delivery: Provide ready-to-upload videos.</li>
              <li>
                Support: Offer insights for maximizing views and engagement.
              </li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1551847677-dc82d764e1eb?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Content planning
          "https://images.unsplash.com/photo-1574375927938-d5a98e8ffe85?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Video editing
          "https://images.unsplash.com/photo-1533228876829-65c94e7b5025?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Camera equipment filming
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="YouTube Video Wins in DIFC"
        description="Our videos have driven YouTube success in DIFC."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Viral Content",
            description: "Increased views with engaging videos.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Channel Growth",
            description: "Boosted subscribers for DIFC brands.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "97% approval from YouTube projects.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Grow Your Channel?</Subheading>}
        heading="YouTube Video Production in DIFC"
        description={
          <Description>
            Partner with MilaajBrandset, a leading YouTube video production
            agency in DIFC. Create professional, engaging videos that elevate
            your channel—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1626368305730-9461fba72d6d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Professional filming
          "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Content creation
          "https://images.unsplash.com/photo-1611162616475-46b635cb6868?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Video production setup
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
